import countries from './countries.json';
import formatNIT from './formatNIT';

function formatIdentifier(identifier : string, preferredLanguage : string ) : string {
  const country = countries.filter(x => x.preferredLanguage === preferredLanguage);

  if(!country || !country[0])
    return identifier;

  if(country[0].preferredLanguage === 'es-CO')
    return formatNIT(identifier);

  if(country[0].regex === '')
    return identifier;

  return identifier.replace(new RegExp(country[0].regex), country[0].format);
}

export default formatIdentifier;